import task from "@commons/task";
import {sa2Toast, sa2Confirm, sa2Alert} from "@commons/sa2Custom";
import {__t} from "@commons/i18nRef";

var baseTask = cpAppSet.currentTask.class;

var visTimeline = null; // Ref

export default function drawRhTimeline(timelineData, timelineEl, timelineScaleEl, rangeInfo = null) {
    var timelineWrapEl = $(timelineEl).parent();

    var now = moment();

    var minBaseDate = now.clone().add(100, 'y');
    var maxBaseDate = now.clone().add(-100, 'y');

    var minDate = minBaseDate.clone();
    var maxDate = maxBaseDate.clone();

    function updateMinMaxDate(startDate, endDate) {
        if (startDate < minDate) {
            minDate = startDate.clone();
        }

        if (endDate > maxDate) {
            maxDate = endDate.clone();
        }
    }

    function getAccount(accountId) {
        const account = timelineData.accounts.find(account => account.accountId === accountId);
        return account ? account : null;
    }

    var timelineItems = [];

    //--- Richeiste da pianificare (toBePlannedInternalTrips)

    var requestInternalTbpGroup = {
        id: "g-request-internal-tbp",
        content: "Richieste",
        nestedGroups: ["g-request-internal-tbp-sub"]
    };

    var requestInternalTbpSubGroup = {
        id: "g-request-internal-tbp-sub",
        content: "Da Associare",
        treeLevel: 2
    };

    $.each(timelineData.toBePlannedInternalTrips, function (index, item) {
        var id = "item-tbp-" + index;

        /*var startDate = moment(item.expectedDepartureDate);
         var endDate = moment(item.expectedArrivalDate);*/
        var startDate = moment(item.departureDate);
        var endDate = moment(item.arrivalDate);

        updateMinMaxDate(startDate, endDate);

        var title = `<b>${__t("Da pianificare")} (id:${item.transportRequestId})</b><br>`;
        title += __t("Dal %s al %s", null, startDate.format("L HH:mm"), endDate.format("L HH:mm"));

        timelineItems.push({
            id: id,
            group: "g-request-internal-tbp-sub",
            content: "",
            start: startDate,
            end: endDate,
            className: "vis-rh-tbp",
            title: title,
            origin: {
                type: "tbp",
                data: item,
            }
        });
    });

    //--- Richeiste pianificate (assignedInternalTrips,plannedInternalTrips,selfUseInternalTrips)    

    var driverGroup = {
        id: "g-driver",
        content: "Autisti",
        nestedGroups: []
    };

    var driverUserMap = new Map();

    driverUserMap.set("g-d-unknow", {
        accountId: null,
        email: null,
        givenName: "Unknown",
        familyName: "Unknown"
    });

    function udateDriverMap(item) {
        var id = "g-d-unknow";
        var account = item.driverId ? getAccount(item.driverId) : null;
        if (account) {
            var id = "g-d-" + account.accountId;
            if (!driverUserMap.has(id)) {
                driverUserMap.set(id, account);
            }
        } else {
            console.log("Missing account " + item.driverId);
        }

        return [id, account];
    }

    $.each(timelineData.assignedInternalTrips, function (index, item) {
        var id = "item-ai-" + index;
        var [groupId, account] = udateDriverMap(item);

        var startDate = moment(item.expectedDepartureDate);
        var endDate = moment(item.expectedArrivalDate);
        updateMinMaxDate(startDate, endDate);

        var title = `<b>${__t("Assegnata")} (id:${item.transportRequestId})</b><br>`;
        title += __t("Dal %s al %s", null, startDate.format("L HH:mm"), endDate.format("L HH:mm"));
        title += `<br>Stato:${item.tripStatus}`;

        var statusClass = item.tripStatus ? (" trip-status-" + item.tripStatus) : "";

        timelineItems.push({
            id: id,
            group: groupId,
            content: "",
            start: startDate,
            end: endDate,
            className: `vis-rh-ai ${statusClass}`,
            title: title,
            origin: {
                type: "ai",
                data: item,
            }
        });
    });

    $.each(timelineData.plannedInternalTrips, function (index, item) {
        var id = "item-pi-" + index;
        var [groupId, account] = udateDriverMap(item);

        var startDate = moment(item.expectedDepartureDate);
        var endDate = moment(item.expectedArrivalDate);
        updateMinMaxDate(startDate, endDate);

        var title = `<b>${__t("Pianificata")} (id:${item.transportRequestId})</b><br>`;
        title += __t("Dal %s al %s", null, startDate.format("L HH:mm"), endDate.format("L HH:mm"));
        title += `<br>Stato:${item.tripStatus}`;

        var statusClass = item.tripStatus ? (" trip-status-" + item.tripStatus) : "";

        timelineItems.push({
            id: id,
            group: groupId,
            content: "",
            start: startDate,
            end: endDate,
            className: `vis-rh-pi ${statusClass}`,
            title: title,
            origin: {
                type: "ai",
                data: item,
            }
        });
    });

    $.each(timelineData.selfUseInternalTrips, function (index, item) {
        var id = "item-su-" + index;
        var [groupId, account] = udateDriverMap(item);

        var startDate = moment(item.expectedDepartureDate);
        var endDate = moment(item.expectedArrivalDate);
        updateMinMaxDate(startDate, endDate);

        var title = `<b>${__t("Uso personale")} (id:${item.transportRequestId})</b><br>`;
        title += __t("Dal %s al %s", null, startDate.format("L HH:mm"), endDate.format("L HH:mm"));
        title += `<br>Stato:${item.tripStatus}`;

        var statusClass = item.tripStatus ? (" trip-status-" + item.tripStatus) : "";

        timelineItems.push({
            id: id,
            group: groupId,
            content: "",
            start: startDate,
            end: endDate,
            className: `vis-rh-su ${statusClass}`,
            title: title,
            origin: {
                type: "su",
                data: item,
            }
        });
    });

    // Genero gruppi utenti autisti e li assegno al gruppo principale
    var driverUserGroups = [];
    driverUserMap.forEach((driver, key) => {
        driverUserGroups.push({
            id: key,
            content: driver.givenName + " " + driver.familyName,
            treeLevel: 2
        });

        driverGroup.nestedGroups.push(key);
    });

    //--- Richeiste esterna (externalTrips) 

    var requestExternalGroup = {
        id: "g-request-external",
        content: "Richieste",
        nestedGroups: ["g-request-external-sub"]
    };

    var requestExternalSubGroup = {
        id: "g-request-external-sub",
        content: "Esterne",
        treeLevel: 2
    };

    $.each(timelineData.externalTrips, function (index, item) {
        var id = "item-ex-" + index;

        var startDate = moment(item.expectedDepartureDate);
        var endDate = moment(item.expectedArrivalDate);
        updateMinMaxDate(startDate, endDate);

        var title = `<b>${__t("Esterna")} (id:${item.transportRequestId})</b><br>`;
        title += __t("Dal %s al %s", null, startDate.format("L HH:mm"), endDate.format("L HH:mm"));
        title += `<br>Stato:${item.tripStatus}`;

        var statusClass = item.tripStatus ? (" trip-status-" + item.tripStatus) : "";

        timelineItems.push({
            id: id,
            group: "g-request-external-sub",
            content: "",
            start: startDate,
            end: endDate,
            className: `vis-rh-ex ${statusClass}`,
            title: title,
            origin: {
                type: "ex",
                data: item,
            }
        });
    });

    var groupsDS = new vis.DataSet();
    groupsDS.add([
        requestInternalTbpGroup,
        requestInternalTbpSubGroup,
        driverGroup,
        ...driverUserGroups,
        requestExternalGroup,
        requestExternalSubGroup,
    ]);

    var itemsDS = new vis.DataSet();
    itemsDS.add(timelineItems);

    // Check final dates------- 
    if (rangeInfo) {
        minDate = rangeInfo.minDate;
        maxDate = rangeInfo.maxDate;
        console.log("Limited by range");
    } else {
        if (minDate.isSame(minBaseDate) || maxDate.isSame(maxBaseDate)) {
            minDate = moment().clone().subtract(6, "days");
            maxDate = moment().clone().add(6, "days");
            console.log("Autofix bad range");
        }
    }

    var dayDelta = maxDate.clone().diff(minDate, 'hours') / 2;
    var middleDate = minDate.clone().add(dayDelta, 'hours'); ///bD
    var moveToRef = middleDate;

    if (rangeInfo === null && now >= minDate && now <= maxDate) {
        moveToRef = now;
    }

    var factor = 3;

    var options = {
        stack: true,
        orientation: {axis: "both"},
        min: minDate.clone().add(-1, 'days').endOf('day').toDate(),
        max: maxDate.clone().add(1, 'days').startOf('day').toDate(),
        start: middleDate.clone().startOf('day').toDate(),
        end: middleDate.clone().startOf('day').add(1 * factor, 'days').toDate(),
        timeAxis: {scale: 'day', step: 1},
        xss: {
            disabled: false,
            filterOptions: {
                whiteList: {
                    p: ['class', 'data-from-template'],
                    div: ['class', 'title'],
                    a: ['class', 'href', 'target'],
                    i: ['class'],
                    br: ['class'],
                    b: ['class']
                }
            }
        },
        tooltip: {
            followMouse: true,
            delay: 100
        }
    };

    if (visTimeline) {
        visTimeline.destroy();
        visTimeline = null;
        console.log("Destroy visTimeline");
    }

    $(timelineWrapEl).attr("class", "mode-day");

    visTimeline = new vis.Timeline(timelineEl.get(0), itemsDS, groupsDS, options);
    setTimeout(function () {
        visTimeline.moveTo(moveToRef);
    }, 0);

    $(timelineScaleEl).off("change").prop('selectedIndex', 2);// reset

    $(timelineScaleEl).on("change", function () {
        var scale = $(this).val();
        var bD = middleDate.clone(); //.startOf('day').add(-1, 'days');                   
        bD.startOf('day');

        switch (scale) {
            case "month":
                visTimeline.setOptions({
                    timeAxis: {scale: 'month', step: 1},
                    start: bD.toDate(),
                    end: bD.clone().add(31 * factor, 'days').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-month");
                break;
            case "week":
                visTimeline.setOptions({
                    timeAxis: {scale: 'week', step: 1},
                    start: bD.toDate(),
                    end: bD.clone().add(7 * factor, 'days').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-week");
                break;
            case "day":
                visTimeline.setOptions({
                    timeAxis: {scale: 'day', step: 1},
                    start: bD.toDate(),
                    end: bD.clone().add(1 * factor, 'days').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-day");
                break;
            case "12":
                visTimeline.setOptions({
                    timeAxis: {scale: 'hour', step: 12},
                    start: bD.toDate(),
                    end: bD.clone().add(24 * factor, 'hours').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-12");
                break;
            case "6":
                visTimeline.setOptions({
                    timeAxis: {scale: 'hour', step: 6},
                    start: bD.toDate(),
                    end: bD.clone().add(12 * factor, 'hours').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-6");
                break;
            case "4":
                visTimeline.setOptions({
                    timeAxis: {scale: 'hour', step: 4},
                    start: bD.toDate(),
                    end: bD.clone().add(8 * factor, 'hours').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-4");
                break;
            case "2":
                visTimeline.setOptions({
                    timeAxis: {scale: 'hour', step: 2},
                    start: bD.toDate(),
                    end: bD.clone().add(4 * factor, 'hours').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-2");
                break;
            case "1":
                visTimeline.setOptions({
                    timeAxis: {scale: 'hour', step: 1},
                    start: bD.toDate(),
                    end: bD.clone().add(2 * factor, 'hours').toDate()
                });
                $(timelineWrapEl).attr("class", "mode-1");
                break;
            default:
        }

        visTimeline.moveTo(moveToRef);
    });

    //Timeline click event------------------------------------------------------
    visTimeline.on('click', function (properties) {
        console.log(properties);

        if (properties.item) {
            var item = itemsDS.get(properties.item);
            var tripData = item.origin.data;
            var tripType = item.origin.type;

            if (!tripData) {
                console.log("Missing tripData");
            }

            var taskMethod = null;
            if (tripType == "tbp") {
                taskMethod = ".edit";
            } else {
                if (tripData.tripStatus && (tripData.tripStatus == "FINISHED" || tripData.tripStatus == "CANCELLED ")) {
                    taskMethod = ".view"
                } else {
                    taskMethod = ".trip"
                }
            }

            window.location.href = task(baseTask + taskMethod, "id=" + tripData.transportRequestId);

        }
    });

}